<template>
  <transition name="fade">
    <div v-if="active" class="fm-dropzone">
      <div class="fm-dropzone-inner">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5"/>
        </svg>
        <span>Suelta aquí para subir</span>
      </div>
    </div>
  </transition>
</template>
<script>
export default { name: 'FMDropZone', props: { active: Boolean } }
</script>
<style scoped>
.fm-dropzone {
  position: absolute; inset: 0;
  display: flex; align-items: center; justify-content: center;
  background: rgba(255,255,255,0.8);
  border: 2px dashed var(--fm-accent);
  border-radius: var(--fm-radius);
  z-index: 50; pointer-events: none;
}
.fm-dropzone-inner {
  display: flex; flex-direction: column; align-items: center;
  gap: 12px; color: var(--fm-primary);
}
.fm-dropzone-inner svg { width: 48px; height: 48px; }
.fm-dropzone-inner span { font-size: 18px; font-weight: 500; }
.fade-enter-active, .fade-leave-active { transition: opacity 0.15s; }
.fade-enter, .fade-leave-to { opacity: 0; }
</style>
